class VisualParameters{
    constructor(duration, speedValue){
        
        this.baseSpeed = duration;
        this.setDurationSpeed(speedValue);
        this.setupDefaultParams();
    }

    setDurationSpeed(speedValue){
        this.duration = this.baseSpeed / speedValue;
    }
    setupDefaultParams(){
        this.paddingLeft = 230;
        this.paddingRight = 230;
        this.paddingTop = 100;
        this.taskYSize = 20;
        this.taskYSpacing = 10;
        this.xScaling = 4;
        this.betweenProjectsSpacing = 80;
        this.milestoneHeight = 10;
        this.milestonePadding = 0 * this.milestoneHeight;
        this.colorMapper = {"G": "#D3D3D3", "B": "#00A1FF", "O": "#FEAE00", "I": "#004D80", "M": "#A33D32", "A": "#16E7CF", "P": "#FF42A1"};
        this.todayLinePadding = 20;
        this.gridLinePadding = 80;

        this.maxZoom = 0.5;
        this.minZoom = 6;

        this.todayBoxWidth = 80;
        this.todayBoxHeight = 28;
        this.todayTextX = 13.5;
        this.todayTextY = 19.5;

        this.updateFutureLoadGraphTime = 1000;
        this.forceAllAssignments = true;
        this.simulateTillEnd = false;        

        this.useCulling = true;
    }

}


module.exports = { VisualParameters };
